import { Select } from "@mui/material";
import React, { useContext } from "react";
import { Terminal } from "../../../../logic/api";
import { SessionContext } from "../../../../utility/useSession";
import FloatingInputLabel from "../components/FloatingInputLabel";


const TerminalField: React.FunctionComponent<{
    label: string,
    value?: Terminal;
    testId?: string;
    onChange: (value: Terminal) => void;
}> = (props) => {
    const session = useContext(SessionContext);


    let selectedTerminalId = -1;
    if (props.value != null) {
        selectedTerminalId = props.value.id;
    }
    return <FloatingInputLabel label={props.label}>
        <Select
            data-testid={props.testId}
            native
            style={{ width: "100%", maxWidth: 225, borderRadius: 5, padding: 5 }}

            value={selectedTerminalId}
            onChange={(e) => {
                if (session.current.site != null) {
                    const selectedTerminal = session.current.site.terminals.filter((access) => {
                        return access.terminal.id == e.target.value;
                    });

                    if (selectedTerminal.length > 0) {
                        props.onChange(selectedTerminal[0].terminal);
                    }
                }
            }}
        >
            <option value={-1} title={""}></option>
            {session.current.site != null && session.current.site.terminals.map((item, i) => {
                return <option key={i} value={item.terminal.id} title={item.terminal.name}>{item.terminal.name}</option>;
            })}

        </Select>
    </FloatingInputLabel>;
}

export default TerminalField;